import { ChevronLeft } from "lucide-react";

const CourseHeader = ({
  darkMode,
  selectedCourse,
  courseDetails,
  semesterType,
  getSemesterTypeDisplayName,
  handleBackToCourses,
}) => (
  <div
    className="flex items-center mb-6 p-4 rounded-lg border"
    style={{
      backgroundColor: darkMode ? "#0D1117" : "#F8FAFC",
      borderColor: darkMode ? "#22232B" : "#E5E7EB",
      boxShadow: darkMode ? "none" : "0 1px 3px rgba(0, 0, 0, 0.05)",
    }}
  >
    <button
      onClick={handleBackToCourses}
      className="flex items-center justify-center mr-4 p-2 rounded-lg border transition-all duration-200"
      style={{
        backgroundColor: darkMode ? "#161B22" : "#FFFFFF",
        border: darkMode ? "none" : "1px solid #000000ff",

        color: darkMode ? "#C9CCD1" : "#374151",
        boxShadow: darkMode ? "none" : "0 1px 2px rgba(0, 0, 0, 0.05)",
      }}
      onMouseEnter={(e) => {
        e.target.style.backgroundColor = darkMode ? "#1F2937" : "#F9FAFB";
        e.target.style.borderColor = darkMode ? "#3B82F6" : "#3B82F6";
        e.target.style.color = darkMode ? "#3B82F6" : "#2563EB";
        e.target.style.transform = "translateX(-2px)";
      }}
      onMouseLeave={(e) => {
        e.target.style.backgroundColor = darkMode ? "#161B22" : "#FFFFFF";
        e.target.style.borderColor = darkMode ? "#22232B" : "#E5E7EB";
        e.target.style.color = darkMode ? "#C9CCD1" : "#374151";
        e.target.style.transform = "translateX(0)";
      }}
    >
      <ChevronLeft size={18} />
    </button>

    <div className="flex-1">
      <div className="flex items-center mb-2">
        <h3
          className="text-xl font-bold"
          style={{ color: darkMode ? "#FFFFFF" : "#111827" }}
        >
          {selectedCourse.course_code} - {selectedCourse.course_title}
        </h3>
      </div>

      <div className="flex flex-wrap items-center gap-3">
        <span
          className="text-sm font-medium px-3 py-1 rounded-full"
          style={{
            backgroundColor: darkMode ? "rgba(59, 130, 246, 0.2)" : "#EFF6FF",
            color: darkMode ? "#93C5FD" : "#1D4ED8",
            border: darkMode ? "none" : "1px solid #BFDBFE",
          }}
        >
          {selectedCourse.credits} Credits
        </span>

        <span
          className="text-sm font-medium px-3 py-1 rounded-full"
          style={{
            backgroundColor: darkMode
              ? semesterType === "odd"
                ? "rgba(249, 115, 22, 0.2)"
                : "rgba(139, 92, 246, 0.2)"
              : semesterType === "odd"
                ? "#FFEDD5"
                : "#EDE9FE",
            color: darkMode
              ? semesterType === "odd"
                ? "#FDBA74"
                : "#C4B5FD"
              : semesterType === "odd"
                ? "#9A3412"
                : "#5B21B6",
            border: darkMode
              ? "none"
              : semesterType === "odd"
                ? "1px solid #FED7AA"
                : "1px solid #DDD6FE",
          }}
        >
          {getSemesterTypeDisplayName(semesterType)}
        </span>
      </div>
    </div>
  </div>
);

export default CourseHeader;
